import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72709690"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex min-w-0 flex-grow flex-col"
}
const _hoisted_2 = {
  key: 0,
  class: "font-normal"
}
const _hoisted_3 = {
  class: "w-full shrink-0 px-1.5 pb-1.5",
  "data-testid": "vacancy-footer"
}
const _hoisted_4 = {
  key: 0,
  class: "font-normal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex w-full", [_ctx.autoHeight ? 'min-h-[34px]' : 'h-[72px] md:h-[105px]', 'overflow-hidden']]),
    style: _normalizeStyle({ background: _ctx.legacy ? '#fef3e7' : _ctx.palette.open.bg })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.legacy ? 'bg-feedBackAlert' : '', _ctx.autoHeight ? 'w-2 shrink-0' : 'w-2 md:w-3']),
      style: _normalizeStyle(_ctx.legacy ? undefined : { background: _ctx.palette.open.stripe })
    }, null, 6),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full flex flex-1 min-h-0", _ctx.contentClass])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.labelClass),
              style: _normalizeStyle(_ctx.labelStyle)
            }, [
              _createTextVNode(" Vaga aberta"),
              (_ctx.detail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " · " + _toDisplayString(_ctx.detail), 1))
                : _createCommentVNode("", true)
            ], 6)
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["w-full flex", _ctx.contentClass])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.labelClass),
            style: _normalizeStyle(_ctx.labelStyle)
          }, [
            _createTextVNode(" Vaga aberta"),
            (_ctx.detail)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " · " + _toDisplayString(_ctx.detail), 1))
              : _createCommentVNode("", true)
          ], 6)
        ], 2))
  ], 6))
}